import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="taggable"
export default class extends Controller {
  static targets = ["input"]
  static values = { tags: Array }

  connect() {
    console.log(this.tagsValue)
    let tagify = new Tagify(this.inputTarget, {
      whitelist: this.tagsValue,
      mode: 'select',
      delimiters: [',', 'Enter'],
      dropdown: {
        enabled: 0,
        maxItems: 100,
      }
    })

    this.tagify = tagify

    tagify.on('blur', (e) => {
      console.log(e.detail.tagify.value);
      console.log(this.inputTarget);
      setTimeout(() => {
        this.cleanInputValue();
      }, 10);
    })

    this.inputTarget.closest('form')?.addEventListener('submit', () => {
      this.cleanInputValue();
    })

    this.cleanInputValue();
  }

  cleanInputValue() {
    if (this.tagify && this.inputTarget) {
      const tagifyValue = this.tagify.value;
      if (Array.isArray(tagifyValue) && tagifyValue.length > 0) {
        const stringValue = tagifyValue[0]?.value || '';
        this.inputTarget.value = stringValue;
      }
    }
  }
}
